import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip } from "recharts"
import { GraficoComponenteProps } from "../../interfaces/dashboardCard"
import { notacaoNumero } from "../../helpers"
import { chavesValoresSiglas } from "../../interfaces/indicadorMensuracao"
import GraficoComponent from "../GraficoComponent"
import NenhumDadoGrafico from "../NenhumDadoGrafico"
import formatarValorTooltip from "../../helpers/formatarDadosGrafico"

export default function GraficoLinha({ indicador }: GraficoComponenteProps) {
  const { sigla, indicadoresMensuracaos } = indicador;
  const chaveValor = sigla.toLowerCase() as keyof chavesValoresSiglas;

  const valores = indicadoresMensuracaos
    .map(dado => Number(dado[chaveValor]))
    .filter(valor => !isNaN(valor));

  let valorMaximo = Math.max(...valores);
  valorMaximo = Math.round(valorMaximo + Math.abs(valorMaximo) * 0.1);

  let valorMinimo = Math.min(...valores);
  valorMinimo = Math.round(valorMinimo - Math.abs(valorMinimo) * 0.1);

  return (
    <GraficoComponent title={indicador.titulo}>
      {indicadoresMensuracaos.length > 0 ? <LineChart data={indicadoresMensuracaos}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="periodo" />
        <YAxis domain={[valorMinimo, valorMaximo]} allowDecimals={false} tickFormatter={notacaoNumero} />
        <Tooltip formatter={(value) => formatarValorTooltip(sigla, value)} />
        <Line type="monotone" dataKey={chaveValor} stroke="#8884d8" />
      </LineChart> :
        <NenhumDadoGrafico texto='Nenhum dado encontrado ' subtexto='para este gráfico' />
      }
    </GraficoComponent>
  );
}
